import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LoadingService } from './core/services/loading-service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { GTMService } from './core/services/gtm-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  protected title = 'Rackspace Email Cart';
  constructor(
    private router: Router,
    public loadingService: LoadingService,
    private render: Renderer2,
    private gtmService: GTMService
  ) {
  }

  ngOnInit(): void {
    this.gtmService.loadGTM();
  }

}